module.exports = __webpack_public_path__ + "assets/bg.b3bfdafe1f37c243a388067d38a6578e.png";